import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Renderer} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {
  BoxedInputChildProps,
  BoxedInputChildStyleProps,
  boxedInputColorReaders,
  inputContentStyles,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {ContentEditable, ContentEditableProps} from '../editor/contentEditable';
import {ServiceSubscription} from '../editor/serviceSubscription';

/*
 * Props.
 */

export interface BoxedInputContentEditableProps extends ContentEditableProps, BoxedInputChildProps {
  className?: string;
  renderPlaceholder?: Renderer;
  maxHeight?: number;
}

/*
 * Style.
 */

interface StyledWrapperDivProps extends BoxedInputChildStyleProps {
  $maxHeight?: number;
}

const StyledWrapperDiv = styled.div<StyledWrapperDivProps>`
  flex: auto;
  overflow-x: hidden;
  ${(p) => inputContentStyles[p.$size]};
  ${maybeAddMaxHeightStyle}
`;

function maybeAddMaxHeightStyle({$maxHeight}: StyledWrapperDivProps) {
  if (!$maxHeight) {
    return '';
  }

  return css`
    max-height: ${$maxHeight}px;
    overflow-y: auto;
  `;
}

const StyledPlaceholderDiv = styled.div`
  position: absolute;
  pointer-events: none;
  color: ${boxedInputColorReaders.textPlaceholder};
`;

/*
 * Component.
 */

export const BoxedInputContentEditable: FC<BoxedInputContentEditableProps> = (props) => (
  <StyledWrapperDiv $size={props.size} $maxHeight={props.maxHeight}>
    {maybeRenderPlaceholder(props)}
    <ContentEditable {...props} />
  </StyledWrapperDiv>
);

function maybeRenderPlaceholder(props: BoxedInputContentEditableProps) {
  const {className, editor, renderPlaceholder} = props;
  if (!renderPlaceholder) {
    return null;
  }

  return (
    <ServiceSubscription source={editor.services.empty}>
      {({isEmpty}) =>
        isEmpty && <StyledPlaceholderDiv className={className}>{renderPlaceholder()}</StyledPlaceholderDiv>
      }
    </ServiceSubscription>
  );
}
